function timeToString(dateTime) {
    if(dateTime == null) return "—";
    dateTime=new Date(dateTime);
    let timeString = `${("0" + dateTime.getHours()).slice(-2)}:${("0" + dateTime.getMinutes()).slice(-2)}:${("0" + dateTime.getSeconds()).slice(-2)}`;
    return timeString;
}

export default timeToString;